import { render, staticRenderFns } from "./ArchivedTemporaryItems.vue?vue&type=template&id=02b4e40c"
import script from "./ArchivedTemporaryItems.vue?vue&type=script&lang=js"
export * from "./ArchivedTemporaryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports